import React from 'react';
import chatScreenshot from '../../logos/chat_snap.png';

const SolutionOverview = () => {
  return (
    <section className="solutionOverview" id="solution">
      <h2>How Dysun resolves issues</h2>
      <div className="solutionGrid">
        <div className="solutionItem">
          <h3>Instant Answers</h3>
          <p>Get immediate responses to your installation queries, no more waiting on hold.</p>
        </div>
        <div className="solutionItem">
          <h3>Strong domain knowledge</h3>
          <p>Searches over your knowledge base and a vast repository of domain knowledge to best answer your questions.</p>
        </div>
        <div className="solutionItem">
          <h3>Credible Sources</h3>
          <p>All answers are backed by cited, reliable sources so you can be confident in the accuracy of the response.</p>
        </div>
      </div>
      <div className="mockup">
        <img src={chatScreenshot} alt="AI Chat Interface Mockup" />
      </div>
    </section>
  );
};

export default SolutionOverview;